import { render, staticRenderFns } from "./ActualPanieri.vue?vue&type=template&id=0818c094&scoped=true"
import script from "./ActualPanieri.vue?vue&type=script&lang=js"
export * from "./ActualPanieri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0818c094",
  null
  
)

export default component.exports